import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showNotification, showAlert, catchHandler } from "../../utils/helpers";
import { status } from "../../utils/common";

const state = {
    degreeDelegnations: [],
    employeeDelegation: {},
    totalItems:0,

};

const getters = {
    index: state => degreeDelegnationId => state.degreeDelegnations.findIndex(i => i.degreeDelegnationId === degreeDelegnationId)
};

const mutations = {
    setDegreeDelegnations: (state, r) => (state.degreeDelegnations = r),
    setTotalItems: (state, totalItems) => (state.totalItems = totalItems),

    add: (state, r) => state.degreeDelegnations.unshift(r),
    delete: (state, index) => state.degreeDelegnations.splice(index, 1),
    setDelegation: (state, r) => (state.employeeDelegation = r),
    edit: (state, { index, transfer }) => state.degreeDelegnations.splice(index, 1, transfer),
    approve: (state, index) => state.degreeDelegnations[index].status = status.approved,
    reject: (state, index) => state.degreeDelegnations[index].status = status.rejected,
    returnEmployee: (state, index) => state.degreeDelegnations[index].status = status.expired,
};

const actions = {
    async getAll({ commit }, params) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");

            startLoading()
            const response = await dataService.degreeDelegnations.getAll(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setDegreeDelegnations", response.data.degreeDelegnations);
            commit("setTotalItems", response.data.totalItems);


        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async add({ commit }, payload) {
        try {
            let formData = new FormData()
            formData.append("currentJobGradeId", payload.currentJobGradeId);
            formData.append("employeeId", payload.employeeId);
            formData.append("startDate", payload.startDate);
            formData.append("endDate", payload.endDate);
            formData.append("delegationReason", payload.delegationReason);
            formData.append("attachmentFile", payload.attachmentFile);
         
            startLoading()
            const response = await dataService.degreeDelegnations.add(formData);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);
            commit("add", response.data.newDelegation);


        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    async delete({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.degreeDelegnations.delete(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);


            const index = getters.index(id);
            commit("delete", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },

    async getDetails({ commit }, id) {
        try {
            commit("setDelegation", {});
            startLoading()
            const response = await dataService.degreeDelegnations.getDetails(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setDelegation", response.data.delegation);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getForEdit(_, id) {
        try {
            startLoading()
            const response = await dataService.degreeDelegnations.getForEdit(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            return Promise.resolve(response.data.transfer);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async edit({ commit, getters }, { id, payload }) {
        try {
            let formData = new FormData()
            formData.append("currentJobGradeId", payload.currentJobGradeId);
            formData.append("employeeId", payload.employeeId);
            formData.append("startDate", payload.startDate);
            formData.append("endDate", payload.endDate);
            formData.append("delegationReason", payload.delegationReason);
            formData.append("attachmentFile", payload.attachmentFile);
         
            startLoading()
            const response = await dataService.degreeDelegnations.edit(id, formData);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            const index = getters.index(id);
            commit("edit", { index, transfer: response.data.transfer });

            /*  return Promise.resolve()*/
        } catch (error) {
            console.log(error)
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },

    async approve({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.degreeDelegnations.approve(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);

            const index = getters.index(id);
            commit("approve", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async reject({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.degreeDelegnations.reject(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);

            const index = getters.index(id);
            commit("reject", index);
        } catch (error) {

            stopLoading()
            catchHandler(error);
        }
    },
    async returnEmployee({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.degreeDelegnations.returnEmployee(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);

            const index = getters.index(id);
            commit("returnEmployee", index);
        } catch (error) {

            stopLoading()
            catchHandler(error);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
